export enum Language {
    EN = 'en',
    CS = 'cs',
    DE = 'de',
    ES = 'es',
    IT = 'it',
    PL = 'pl',
    RU = 'ru',
}

export const supportedLanguages: Language[] = Object.values(Language);
